import { ReactSortable } from 'react-sortablejs';

import { TableCustomizationItem } from './TableCustomizationItem';
import { TableColumnSettings } from './TableCustomizationModal';

import styles from './table-customization.module.scss';

type TableCustomizationSortableProps = {
  value: TableColumnSettings[];
  onChange: (newValue: TableColumnSettings[]) => void;
};
export function TableCustomizationSortable({
  value,
  onChange,
}: TableCustomizationSortableProps) {
  return (
    <ReactSortable
      group="columnCustomization"
      className={styles['sortable']}
      list={value}
      setList={(newState) => onChange(newState)}
    >
      {value.map((settings) => {
        return (
          <TableCustomizationItem
            {...settings}
            key={settings.id}
            onChange={(id, isVisible) => {
              onChange(
                value.map((v) => (id === v.id ? { ...v, isVisible } : v))
              );
            }}
          />
        );
      })}
    </ReactSortable>
  );
}
